import { p as publicOnlyInstance } from "../../../chunks/env.js";
import { error } from "@sveltejs/kit";
const load = async () => {
  if (publicOnlyInstance) {
    error(404, "Not Found");
  }
  return;
};
export {
  load
};
